import $ from 'jquery'

export default navbarMenuDesktopFixed

/** @ngInject */
function navbarMenuDesktopFixed($timeout, DeviceChecker) {
    return ({
        restrict: 'C',
        scope: {
            isCollapsed: '=',
        },
        link(scope, element) {
            return $timeout(() => {
                const $window = $(window)
                const $navbarDashboard = $('.navbar-dashboard')
                $window.on('scroll.navPlumScrollable', () => {
                    if (!DeviceChecker.isMobile()) {
                        const windowOffetTop = $(window).scrollTop()
                        const navbarDashboardOffsetBottom = $navbarDashboard.offset().top + $navbarDashboard.height()
                        if (windowOffetTop >= navbarDashboardOffsetBottom) {
                            return element.addClass('navbar-menu-desktop-fixed-visible')
                        }
                        return element.removeClass('navbar-menu-desktop-fixed-visible')
                    }
                })

                return scope.$on('$destroy', () => $window.off('.navPlumScrollable'))
            })
        },
    })
}



// WEBPACK FOOTER //
// ./src/states/navbar/navbarMenuDesktopFixed.js